// extracted by mini-css-extract-plugin
module.exports = {"locationText":"location_locationText__3SAe4","more":"location_more__1-jGC","moreOpen":"location_moreOpen__2HfXi","name":"location_name__1FiUc"};